import { render, staticRenderFns } from "./lableTable.vue?vue&type=template&id=97828cde&scoped=true"
import script from "./lableTable.vue?vue&type=script&lang=js"
export * from "./lableTable.vue?vue&type=script&lang=js"
import style0 from "./lableTable.vue?vue&type=style&index=0&id=97828cde&prod&lang=scss"
import style1 from "./lableTable.vue?vue&type=style&index=1&id=97828cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97828cde",
  null
  
)

export default component.exports